import { useGraphql } from 'utils/hooks/useGraphql';
import { useSelector } from 'react-redux';

import { fetchJourneyNodeQuery } from 'api/queries/workflows';
import {
  WorkflowsRootState,
  getIsClonedNodeInvalid,
  getWorkflowState,
} from 'modules/workflows/ducks';
import { parseBackendNode } from 'modules/workflows/utils';

export const useFetchClonedFromNodeData = (id: string, workflowType: string) => {
  const wfState = useSelector(getWorkflowState);
  const isInvalidNode = useSelector((state: WorkflowsRootState) =>
    getIsClonedNodeInvalid(state, id),
  );
  const nodeId = Number(id);

  const { data, isLoading = false } = useGraphql(fetchJourneyNodeQuery, {
    variables: {
      nodeId,
      journeyType: workflowType,
    },
    skip: !isInvalidNode || nodeId < 0,
  });

  if (isLoading) return { isLoading };

  const clonedNode = data?.journeyNode?.clonedFromNode;

  if (!clonedNode) return {};

  const parsedNodeData = parseBackendNode(clonedNode, wfState, { shouldValidate: false });

  return { clonedFromNodeData: parsedNodeData.nodeData, isLoading: false };
};
